import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pill-linkedin',
    templateUrl: './pill-linkedin.component.html',
    styleUrls: ['./pill-linkedin.component.scss'],
})
export class PillLinkedinComponent implements OnInit {
    @Input() linkedinUrl: string;

    constructor() {}

    ngOnInit(): void {}
}
